import { render } from "./Payment_Plans.vue?vue&type=template&id=90fc1ab4"
import script from "./Payment_Plans.vue?vue&type=script&lang=js"
export * from "./Payment_Plans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__